document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', (e) => {
    const bundle_item = e.target.closest('.lineitem_bundle_item');
    if (bundle_item) {
      const qty = bundle_item.getAttribute('data_qty');
      const parent = bundle_item.closest('.line-item');
      const qty_input = parent.querySelector('.quantity-selector__input');

      if (qty_input) {
        qty_input.value = parseInt(qty);
        qty_input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });
});


document.addEventListener('click', function(event) {
  const free_gift_btn = event.target.closest('.fgi-atc-btn');
  if (!free_gift_btn) return;

  const gift_id = parseInt(free_gift_btn.getAttribute('data-id'));
  if (!gift_id) return;

  free_gift_btn.setAttribute('disabled', true);

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [
        {
          id: gift_id,
          quantity: 1
        }
      ]
    })
  })
  .then(res => res.json())
  .then(cartData => {
    free_gift_btn.removeAttribute('disabled');

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          cart: cartData,
          openMiniCart: true,
          replacementDelay: 0
        }
      })
    );
  })
  .catch(err => {
    free_gift_btn.removeAttribute('disabled');
    console.error("❌ Error adding bundle:", err);
  });
});

document.addEventListener('cart:refresh', function(event) {
  const mini_drawer = document.querySelector('#mini-cart');
  if (!mini_drawer) return;

  const freegift_id = parseInt(mini_drawer.getAttribute('data-freegift-id'));
  const freegift_count = parseInt(mini_drawer.getAttribute('data-freegift-count'));

  const cart = event.detail?.cart;
  if (!cart || !cart.items) return;

  const freeGiftItem = cart.items.find(item => item.variant_id == freegift_id);

  if (!freeGiftItem) return;

  if (cart.item_count < freegift_count) {

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        updates: {
          [freegift_id]: 0
        }
      })
    })
    .then(res => res.json())
    .then(updatedCart => {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            cart: updatedCart,
            openMiniCart: true,
            replacementDelay: 0
          }
        })
      );
    })
    .catch(err => console.error('Free gift remove error:', err));
  }
});


